export const userStatus = {
  INACTIVE: {
    value: 0,
    label(t: (key: string) => string) {
      return t('staff.status.pending')
    },
    color: 'orange'
  },
  NORMAL: {
    value: 1,
    label(t: (key: string) => string) {
      return t('staff.status.active')
    },
    color: 'green'
  },
  DISABLED: {
    value: 2,
    label(t: (key: string) => string) {
      return t('staff.status.disabled')
    },
    color: 'red'
  }
} as const

export type StaffStatus = typeof userStatus[keyof typeof userStatus]['value']

export function getStaffStatusLabel(status: number, t: (key: string) => string): string {
  switch (status) {
    case userStatus.INACTIVE.value:
      return t('staff.status.pending') // 修正为“待激活”
    case userStatus.NORMAL.value:
      return t('staff.status.active')
    case userStatus.DISABLED.value:
      return t('staff.status.disabled')
    default:
      return t('staff.status.unknown')
  }
}
